import http from '../http-common'

class IBuyService {
  async validateRedemptionCode(code) {
    const response = await http.get(`/ibuy/redeem/status/${code}`)
    if (response.data.error) {
      throw new Error(response.data.error.message)
    }
    return response.data
  }

  async cancelRedeem(code) {
    const response = await http.put(`/ibuy/redeem/cancel`, {
      code: code,
    })
    if (response.data.error) {
      throw new Error(response.data.error.message)
    }
    return response.data
  }
}

export default new IBuyService()
